import React, { Component } from "react";
import "./custom.css";
import { NavMenu } from "./components/NavMenu";
import { UserContextProvider, useUserDispatch } from "./systems/UserContext";
import MainRouter from "./systems/MainRouter";
import { Route, Switch, useHistory } from "react-router-dom";
import Login from "./Page/Login";
import UserRoute from "./systems/UserRoute";
import UserService from "./systems/UserService";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import LoginRedirect from "./azure/LoginRedirect";
import { loginRequest } from "./azure/AuthConfig";

export default class App extends Component {
   static displayName = App.name;

   //Main Router
   render() {
      return (
         <>
            <UnauthenticatedTemplate>
               <LoginRedirect></LoginRedirect>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
               <UserContextProvider>
                  <MyApp></MyApp>
               </UserContextProvider>
            </AuthenticatedTemplate>
         </>
      );
   }
}

// 이전에 로그인 했었는데, 새로고침 등으로 인해 App이 재로딩 되었다.
// token을 re-setting 해주어야 한다
function MyApp() {
   const dispatch = useUserDispatch();
   const [isInit, setIsInit] = React.useState(false);
   const { instance, accounts } = useMsal();
   const history = useHistory();

   React.useEffect(() => {
      let savedToken = window.sessionStorage.getItem("token");

      const getToken = async (token) => {
         try {
            let _token = token;

            if (_token === undefined) {
               const response = await instance.acquireTokenSilent({
                  ...loginRequest,
                  scopes: [process.env.REACT_APP_MSAL_SCOPE],
                  account: accounts[0],
               });
               _token = response.accessToken;
               window.sessionStorage.setItem("token", _token);
            }
            UserService.SetToken(_token);
            return _token;
         } catch (error) {
            console.error(error);
         }
      };

      const ssoLogin = async (savedToken) => {
         if (!savedToken) {
            savedToken = await getToken();
            if (!savedToken) {
               alert("로그인 정보 처리 중 에러가 발생하였습니다.");
               window.location.replace("https://testportal.weareinbody.com");
               return;
            }
         }

         try {
            const res = await UserService.SSOLogin(savedToken);
            console.log(res.data);
            dispatch({ type: "LOGIN", item: res.data.user });
            //메인페이지로 이동
            history.push("/");
         } catch (error) {
            if (error.response) {
               if (error.response.status === 401) {
                  window.sessionStorage.removeItem("token");
                  history.push("/login");
               } else {
                  alert("등록되지 않은 이메일로 접속이 불가능합니다.");
                  window.location.replace("https://testportal.weareinbody.com");
               }
            }
         } finally {
            setIsInit(true);
         }
      };

      ssoLogin(savedToken);
   }, [accounts, dispatch, history, instance]);

   if (!isInit) {
      // 아직 준비되지 않았으면 빈 화면을 보여준다.
      // 로딩 중이라고 endUser가 느낄 수 있도록
      return <div></div>;
   } else {
      return (
         <>
            <Switch>
               <Route path="/login">
                  <Login></Login>
               </Route>
               <UserRoute path="/" component={Layout}></UserRoute>
            </Switch>
         </>
      );
   }
}

function Layout() {
   return (
      <>
         <NavMenu></NavMenu>
         <MainRouter></MainRouter>
      </>
   );
}
